var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "container",
      staticClass: "container-fluid mr-main-dashboard-container",
      style: _vm.containerStyles,
    },
    [
      _c(
        "el-row",
        {
          staticStyle: { "flex-flow": "column wrap" },
          attrs: { type: "flex" },
        },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("gantt-filter", {
                attrs: {
                  isEnableAllTrucks: _vm.isEnableAllTrucks,
                  defaultRViews: _vm.routeViewOptions,
                  isVerticallyAutoScrolling: true,
                  isDashboard: true,
                  isPlay: _vm.isPlay,
                  isPause: _vm.isPause,
                },
                on: {
                  onEnableAllTrucks: _vm.handleEnableAllTrucks,
                  onDisableAllTrucks: _vm.handleDisableAllTrucks,
                  onTimeStepperChanges: _vm.handleTimeStepperChanges,
                  onRouteViewsChanges: _vm.handleRouteViewsChanges,
                  onGCPlay: _vm.handleGCPlay,
                  onGCPause: _vm.handleGCPause,
                },
              }),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              !_vm.loading
                ? _c("gantt-chart", {
                    attrs: {
                      planViewType: _vm.planViewType,
                      defaultStartDate: _vm.startDate,
                      defaultEndDate: _vm.endDate,
                      defaultTimeStepper: _vm.timeStepper,
                      ganttChartHeight: _vm.gcHeight,
                      isVerticallyAutoScrolling: true,
                      isDashboard: true,
                      isEnableAllTrucks: _vm.isEnableAllTrucks,
                      initAutoAddedDays: _vm.initAutoAddedDays,
                      routeViewOptions: _vm.routeViewOptions,
                      currentPlanId: _vm.currentPlanId,
                      isPlay: _vm.isPlay,
                      isPause: _vm.isPause,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("countdown", {
        ref: "countdown",
        attrs: { defaultRefreshTime: _vm.refreshTime },
        on: { onCountdownZero: _vm.handleCountdownZero },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }